module.exports = __webpack_public_path__ + "img/wx.1af68010.png";